import { render, staticRenderFns } from "./ClientLoanCard.vue?vue&type=template&id=4b45b016&"
import script from "./ClientLoanCard.vue?vue&type=script&lang=ts&"
export * from "./ClientLoanCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports